import type { LeadsTableRow } from '@ekhodealer/ekho-common';

import { StageActionMenu } from '../StageActionMenu';

export interface StageCellProps {
	item: LeadsTableRow;
}

export const StageCell = ({ item }: StageCellProps) => {
	return <StageActionMenu item={item} />;
};
